export function scrollTo(positionId) {
  const sectionEle = document.getElementById(positionId);
  if (!sectionEle) return;

  const headerEl = document.getElementById('partner-detail-header');
  if (!headerEl) return;

  const partnerDetailHeaderOffsetHeight = headerEl.offsetHeight;
  const editHeaderContainerEl = document.getElementsByClassName('edit-header-container')[0];
  const { top } = sectionEle.getBoundingClientRect();

  let result =
    window.scrollY === 0
      ? top - (editHeaderContainerEl ? editHeaderContainerEl.offsetHeight : 0)
      : top + window.scrollY;

  result -= partnerDetailHeaderOffsetHeight;
  if (editHeaderContainerEl) {
    result -= editHeaderContainerEl.offsetHeight;
  }
  window.scrollTo({ left: 0, top: result, behavior: 'smooth' });
}

export function openComponent(step) {
  if (step.behavior === 'EMIT') {
    window.$eventBus.$emit(step.info);
  } else {
    scrollTo(step.info);
  }
}